import '@babel/polyfill'
import 'whatwg-fetch'
// import styles from '../css/app.pcss'

import 'lazysizes'

import { ready, query, copyLink } from './_lib/functions'

// Create observer object.
import { Observer } from './_lib/observer'
window.observer = new Observer()

import { EventBus } from './global/event-bus'
import axios from 'axios'

import Color from 'color-convert'

// App main
const main = async () => {
  // Import Component CSS
  await import(/* webpackChunkName: "calendar" */ '@fullcalendar/core/main.css')
  await import(/* webpackChunkName: "calendar" */ '@fullcalendar/daygrid/main.css')
  await import(/* webpackChunkName: "calendar" */ '@fullcalendar/timegrid/main.css')

  // Import our CSS
  // await import(/* webpackChunkName: "tiny-slider" */ 'tiny-slider/src/tiny-slider.scss')
  // await import(/* webpackChunkName: "choices" */ 'choices.js/src/styles/choices.scss')
  await import(/* webpackChunkName: "vue" */ 'vue-multiselect/dist/vue-multiselect.min.css')
  // const Styles = await import(/* webpackChunkName: "styles" */ '../css/app.pcss')
  await import(/* webpackChunkName: "styles" */ '../scss/styles.scss')

  // Async load the vue module
  const { default: Vue } = await import(/* webpackChunkName: "vue" */ 'vue')
  const { default: Multiselect } = await import(/* webpackChunkName: "vue" */ 'vue-multiselect')

  // Async load the vue apollo module
  const { default: VueApollo } = await import(/* webpackChunkName: "vue-graphql" */ 'vue-apollo')
  const { ApolloClient } = await import(/* webpackChunkName: "vue-graphql" */ 'apollo-client')
  const { HttpLink } = await import(/* webpackChunkName: "vue-graphql" */ 'apollo-link-http')
  const { ApolloLink, concat } = await import(/* webpackChunkName: "vue-graphql" */ 'apollo-link')
  const { InMemoryCache, IntrospectionFragmentMatcher } = await import(
    /* webpackChunkName: "vue-graphql" */ 'apollo-cache-inmemory'
  )
  // TODO: This is kind of hackish since it doesn't actually provide any fragment type data but it works anyways.
  // But we need a way to dynamically call
  const introspectionQueryResultData = {
    __schema: {
      types: [],
    },
  }

  // Misc Libraries
  // const { default: Choices } = await import(/* webpackChunkName: "choices" */ 'choices.js')
  const { default: VMasker } = await import(/* webpackChunkName: "vanilla-masker" */ 'vanilla-masker')

  // HTTP connection to the API
  const httpLink = new HttpLink({
    // You should use an absolute URL here
    uri: '/api',
  })
  const authMiddleware = new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    operation.setContext({
      headers: {
        authorization: `bearer ${graphQLToken}`,
      },
    })
    return forward(operation)
  })
  // Cache implementation
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData,
  })
  const cache = new InMemoryCache({ fragmentMatcher })
  // Create the apollo client
  const apolloClient = new ApolloClient({
    link: concat(authMiddleware, httpLink),
    cache,
  })
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
  })
  Vue.use(VueApollo)

  Vue.component('multiselect', Multiselect)

  // Create our vue instance
  const vm = new Vue({
    el: '#app',
    apolloProvider,
    components: {
      uploads: () => import(/* webpackChunkName: "uploads" */ '../vue/Uploads.vue'),
      calendar: () => import(/* webpackChunkName: "calendar" */ '../vue/Calendar.vue'),
      modal: () => import(/* webpackChunkName: "modal" */ '../vue/Modal.vue'),
      creategallery: () => import(/* webpackChunkName: "modal" */ '../vue/elements/CreateGallery.vue'),
      sharegallery: () => import(/* webpackChunkName: "modal" */ '../vue/elements/ShareGallery.vue'),
      selectgallery: () => import(/* webpackChunkName: "modal" */ '../vue/elements/SelectGallery.vue'),
      downloadimage: () => import(/* webpackChunkName: "modal" */ '../vue/elements/DownloadImage.vue'),
      modalaccess: () => import(/* webpackChunkName: "modal" */ '../vue/elements/ModalAccess.vue'),
      modalevent: () => import(/* webpackChunkName: "modal" */ '../vue/elements/ModalEvent.vue'),
      gallery: () => import(/* webpackChunkName: "gallery" */ '../vue/Gallery.vue'),
      media: () => import(/* webpackChunkName: "media" */ '../vue/Media.vue'),
      mediaDetail: () => import(/* webpackChunkName: "media-detail" */ '../vue/MediaDetail.vue'),
      mediaTypeSelector: () => import(/* webpackChunkName: "media" */ '../vue/elements/MediaTypeSelector.vue'),
      signature: () => import(/* webpackChunkName: "media" */ '../vue/Signature.vue'),
      notifications: () => import(/* webpackChunkName: "notifications" */ '../vue/Notifications.vue'),
      // 'cards': () => import(/* webpackChunkName: "cards" */ '../vue/Cards.vue'),
    },
    data: {
      createGallery: false,
      shareGallery: false,
      shareGalleryUid: false,
      selectGallery: false,
      selectGalleryUid: false,
      downloadImage: false,
      downloadImageUid: false,
      accessModal: false,
      accessType: false,
      accessUid: false,
      eventModal: false,
      eventModalData: false,
      colorType: 'hex',
      galleryFavorites: [],
      favoritesLoaded: false,
    },
    watch: {
      colorType(type) {
        EventBus.$emit('color-type', type)
      },
    },
    methods: {
      openCreateGallery() {
        this.createGallery = true
      },
      closeCreateGallery() {
        this.createGallery = false
      },
      openShareGallery(galleryInfo) {
        this.shareGalleryInfo = galleryInfo
        this.shareGallery = true
      },
      closeShareGallery() {
        this.shareGallery = false
        this.shareGalleryInfo = false
      },
      openSelectGallery(uid) {
        this.selectGalleryUid = uid
        this.selectGallery = true
      },
      closeSelectGallery() {
        this.selectGallery = false
        this.selectGalleryUid = false
      },
      openDownloadImage(assetUid) {
        this.downloadImageUid = assetUid
        this.downloadImage = true
      },
      closeDownloadImage() {
        this.downloadImage = false
        this.downloadImageUid = false
      },
      openAccessModal(accessType, uid) {
        this.accessType = accessType
        this.accessUid = uid
        this.accessModal = true
      },
      closeAccessModal(type) {
        this.accessModal = false
        this.accessType = false
        this.accessUid = false
      },
      openEventModal(eventData) {
        this.eventModalData = eventData
        this.eventModal = true
      },
      closeEventModal() {
        this.eventModalData = false
        this.eventModal = false
      },
      async favoriteGallery(galleryUid) {
        try {
          let formData = new FormData()
          formData.append(csrfTokenName, csrfTokenValue)
          formData.append('favorite', !this.galleryFavorites.includes(galleryUid))
          let response = await axios({
            method: 'post',
            url: `/gallery/favorite/${galleryUid}`,
            data: formData,
          })
          if (response.status === 200) {
            if (response.data.status === 'success') {
              if (response.data.favorite) {
                this.galleryFavorites.push(galleryUid)
              } else {
                let i = this.galleryFavorites.indexOf(galleryUid)
                this.galleryFavorites.splice(i, 1)
              }
            }
          }
        } catch (err) {
          console.error(err)
        }
      },
      rgbLinks(hex) {
        let rgb = Color.hex.rgb(hex)
        return `${copyLink(rgb[0], rgb[0])}, ${copyLink(rgb[1], rgb[1])}, ${copyLink(rgb[2], rgb[2])}`
      },
      cmykLinks(hex) {
        let cmyk
        if (hex.startsWith('#')) {
          cmyk = Color.hex.cmyk(hex)
        } else {
          cmyk = hex.split(',')
        }
        return `${copyLink(cmyk[0], cmyk[0])}, ${copyLink(cmyk[1], cmyk[1])}, ${copyLink(cmyk[2], cmyk[2])}, ${copyLink(
          cmyk[3],
          cmyk[3]
        )}`
      },
    },
    created() {
      EventBus.$on('openCreateGallery', this.openCreateGallery)
      EventBus.$on('closeCreateGallery', this.closeCreateGallery)
      EventBus.$on('openShareGallery', this.openShareGallery)
      EventBus.$on('closeShareGallery', this.closeShareGallery)
      EventBus.$on('openSelectGallery', this.openSelectGallery)
      EventBus.$on('closeSelectGallery', this.closeSelectGallery)
      EventBus.$on('openDownloadImage', this.openDownloadImage)
      EventBus.$on('closeDownloadImage', this.closeDownloadImage)
      EventBus.$on('openAccessModal', this.openAccessModal)
      EventBus.$on('closeAccessModal', this.closeAccessModal)
      EventBus.$on('openEventModal', this.openEventModal)
      EventBus.$on('closeEventModal', this.closeEventModal)
    },
    async mounted() {
      document.body.style.transform = ''
      document.body.style.opacity = ''
      setTimeout(() => {
        document.body.style.transition = ''
      }, 250)
      query('[data-mask]').forEach(input => {
        VMasker(input).maskPattern(input.getAttribute('data-mask'))
      })
      if (userLoggedIn) {
        let response = await axios({
          method: 'get',
          url: '/gallery/favorites',
        })
        if (response.status === 200) {
          this.galleryFavorites = response.data.favorites
          this.favoritesLoaded = true
        }
      }
    },
  })

  // Page Transition
  await import(/* webpackChunkName: "global" */ './global/page-transition.js')

  // Prevent Default
  await import(/* webpackChunkName: "global" */ './global/prevent-default.js')

  // Navigation
  await import(/* webpackChunkName: "global" */ './global/navigation.js')

  // Form Validation
  await import(/* webpackChunkName: "global" */ './global/form-validation.js')

  // Clipboard
  await import(/* webpackChunkName: "global" */ './global/clipboard.js')

  // Trianglify
  await import(/* webpackChunkName: "global" */ './global/trianglify.js')

  // Mobile VH
  import(/* webpackChunkName: "global" */ './global/mobile-vh').then(({ default: mobileVh }) => mobileVh())

  // Search
  await import(/* webpackChunkName: "search" */ './global/search.js')

  // Some custom stuff
  await import(/* webpackChunkName: "accordion" */ './components/accordion.js')
  await import(/* webpackChunkName: "color-card" */ './components/color-card.js')
  await import(/* webpackChunkName: "accordion" */ './components/color-kit.js')
  await import(/* webpackChunkName: "jump-links" */ './components/jump-links.js')
  await import(/* webpackChunkName: "search-selector" */ './components/search-selector.js')
  await import(/* webpackChunkName: "form" */ './components/freeform.js')
  // await import(/* webpackChunkName: "tooltips" */ './components/tooltips.js')
}

if (!window.crypto && window.msCrypto) {
  window.crypto = window.msCrypto
}

ready(() => {
  document.documentElement.className += ' ' + navigator.sayswho.toLowerCase().replace(' ', '-')
  // Execute async function
  main().then(() => {})
})
